import React, { useContext, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import ReactPlayerVimeo from "react-player/vimeo"
import ReactPlayerYouTube from "react-player/youtube"

import Image from "@atoms/Image/Image"
import { IntersectionContext } from "@atoms/IntersectionObserver/IntersectionObserver"
import "@lang/i18n"

import styles from "./VideoReactPlayer.module.scss"

function youtube_parser(url) {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  var match = url?.match(regExp)
  return match && match[7].length === 11 ? match[7] : false
}

const VideoReactPlayer = ({
  type,
  url,
  posterImage,
  autoplayWhenVisible = false,
}) => {
  let ReactPlayer = null
  let videoID = null
  let thumbnailUrl = null

  switch (type) {
    case "youtube":
      ReactPlayer = ReactPlayerYouTube
      videoID = youtube_parser(url)
      thumbnailUrl = videoID
        ? `https://i3.ytimg.com/vi/${videoID}/maxresdefault.jpg`
        : null
      break
    case "vimeo":
      ReactPlayer = ReactPlayerVimeo
      break
    default:
  }

  const { t } = useTranslation()
  const [play, setPlay] = useState(false)
  const [playedOnce, setPlayedOnce] = useState(false)

  const video = useRef()

  useEffect(() => {
    if (video) {
      if (play) {
        video.current?.play()
      } else {
        video.current?.pause()
      }
    }
  })

  useEffect(() => {
    if (play) {
      setPlayedOnce(true)
    }
  }, [play])

  const thumbnail = posterImage
    ? posterImage
    : thumbnailUrl
    ? { sourceUrl: thumbnailUrl }
    : false

  // Autoplay when visible

  const { inView } = useContext(IntersectionContext)

  useEffect(() => {
    if (inView && autoplayWhenVisible) {
      setPlay(true)
    } else {
      setPlay(false)
    }
  }, [inView, autoplayWhenVisible])

  return ReactPlayer ? (
    <>
      <section className={`${styles.element} ${play ? styles.statePlay : ""} `}>
        <div className={styles.content}>
          <div className={styles.trigger}>
            <button onClick={() => setPlay(true)} aria-label={t("Play video")}>
              <span></span>
              <span className="screen-reader-text" aria-hidden>
                {t("Play video")}
              </span>
            </button>
          </div>
        </div>

        {thumbnail && (
          <div className={styles.poster}>
            <Image
              image={thumbnail}
              fill={true}
              ariaHidden={true}
              disableCloudinary={!posterImage}
              alt=""
            />
          </div>
        )}

        <div className={styles.video}>
          <div className={styles.videoContainer}>
            {playedOnce && ReactPlayer.canPlay(url) && (
              <ReactPlayer
                url={url}
                width="100%"
                height="100%"
                playing={play}
                controls={true}
                muted={autoplayWhenVisible}
              />
            )}
            {!ReactPlayer.canPlay(url) && (
              <video // eslint-disable-line jsx-a11y/media-has-caption
                ref={video}
                controls={play}
                preload="metadata"
                playsInline=""
                poster={thumbnail ? thumbnail : undefined}
                tabIndex="-1"
                src={url}
              ></video>
            )}
          </div>
        </div>
      </section>
    </>
  ) : (
    ""
  )
}

export default VideoReactPlayer
